/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Blank_Frames_TitleInputs */

const en_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Blank Frames`)
};

const fr_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer des images vides`)
};

const de_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Rahmen einfügen`)
};

const it_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci cornici vuote`)
};

const ru_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте пустые рамки`)
};

const es_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar marcos en blanco`)
};

const zh_cn2_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入空白帧`)
};

const ja_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白フレームを挿入する`)
};

const hi_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डालें`)
};

const pt_pt2_insert_blank_frames_title = /** @type {(inputs: Insert_Blank_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir molduras em branco`)
};

/**
* | output |
* | --- |
* | "Insert Blank Frames" |
*
* @param {Insert_Blank_Frames_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_blank_frames_title = /** @type {((inputs?: Insert_Blank_Frames_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Blank_Frames_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_blank_frames_title(inputs)
	if (locale === "de") return de_insert_blank_frames_title(inputs)
	if (locale === "it") return it_insert_blank_frames_title(inputs)
	if (locale === "ru") return ru_insert_blank_frames_title(inputs)
	if (locale === "es") return es_insert_blank_frames_title(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_blank_frames_title(inputs)
	if (locale === "ja") return ja_insert_blank_frames_title(inputs)
	if (locale === "hi") return hi_insert_blank_frames_title(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_blank_frames_title(inputs)
	return en_insert_blank_frames_title(inputs)
});